import PropTypes from 'prop-types';
import * as Styled from './Style';
const DatepickerButton = ({
  title,
  onClick,
  ...otherProps
}) => /*#__PURE__*/React.createElement(Styled.Button, {
  onClick: onClick,
  ...otherProps,
  type: "button"
}, title);
DatepickerButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default DatepickerButton;